<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备ID" prop="deviceId" >
        <a-input v-model="form.deviceId" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="视频地址" prop="videoUrl" >
        <a-input v-model="form.videoUrl" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="封面图地址" prop="coverUrl" >
        <a-input v-model="form.coverUrl" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="视频时长(秒)" prop="durationSeconds" >
        <a-input v-model="form.durationSeconds" placeholder="请输入视频时长(秒)" />
      </a-form-model-item>
      <a-form-model-item label="文件大小(字节)" prop="fileSize" >
        <a-input v-model="form.fileSize" placeholder="请输入文件大小(字节)" />
      </a-form-model-item>
      <a-form-model-item label="录制日期" prop="recordDate" >
      </a-form-model-item>
      <a-form-model-item label="下载次数" prop="downloadCount" >
        <a-input v-model="form.downloadCount" placeholder="请输入下载次数" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/mibo/video'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        deviceId: null,

        userId: null,

        videoUrl: null,

        coverUrl: null,

        durationSeconds: null,

        fileSize: null,

        recordDate: null,

        downloadCount: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceId: [
          { required: true, message: '设备ID不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        videoUrl: [
          { required: true, message: '视频地址不能为空', trigger: 'blur' }
        ],
        coverUrl: [
          { required: true, message: '封面图地址不能为空', trigger: 'blur' }
        ],
        durationSeconds: [
          { required: true, message: '视频时长(秒)不能为空', trigger: 'blur' }
        ],
        fileSize: [
          { required: true, message: '文件大小(字节)不能为空', trigger: 'blur' }
        ],
        recordDate: [
          { required: true, message: '录制日期不能为空', trigger: 'blur' }
        ],
        downloadCount: [
          { required: true, message: '下载次数不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceId: null,
        userId: null,
        videoUrl: null,
        coverUrl: null,
        durationSeconds: null,
        fileSize: null,
        recordDate: null,
        downloadCount: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateVideo(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVideo(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
